export enum AssetOrderBy {
  None = 0,
  CreatedDateNewerFirst = 1,
  CreatedDateOlderFirst = 2,
  NameAsc = 3,
  NameDesc = 4,
  PercentsFundedAsc = 5,
  PercentsFundedDesc = 6,
  ClosingDateAsc = 7,
  ClosingDateDesc = 8,
}


// tslint:disable-next-line:no-namespace
export namespace AssetOrderBy {
  export function toString(orderBy: AssetOrderBy): string {
    switch (orderBy) {
      case AssetOrderBy.None:
      case AssetOrderBy.CreatedDateNewerFirst:
        return 'Time Added: Newer first';
      case AssetOrderBy.CreatedDateOlderFirst:
        return 'Time Added: Older first';
      case AssetOrderBy.NameAsc:
        return 'Name: A-Z';
      case AssetOrderBy.NameDesc:
        return 'Name: Z-A';
      case AssetOrderBy.PercentsFundedAsc:
        return '% funded: lower first';
      case AssetOrderBy.PercentsFundedDesc:
        return '% funded: higher first';
      case AssetOrderBy.ClosingDateAsc:
        return 'Closing date: ascending';
      case AssetOrderBy.ClosingDateDesc:
        return 'Closing date: descending';

    }
  }

  export function listAll() {
    return [
      AssetOrderBy.ClosingDateAsc,
      AssetOrderBy.ClosingDateDesc,
      AssetOrderBy.CreatedDateNewerFirst,
      AssetOrderBy.CreatedDateOlderFirst,
      AssetOrderBy.NameAsc,
      AssetOrderBy.NameDesc,
      AssetOrderBy.PercentsFundedAsc,
      AssetOrderBy.PercentsFundedDesc,
    ];
  }

  export function optionsForFundraisingAssets() {
    return [
      AssetOrderBy.ClosingDateAsc,
      AssetOrderBy.ClosingDateDesc,
      AssetOrderBy.CreatedDateNewerFirst,
      AssetOrderBy.CreatedDateOlderFirst,
      AssetOrderBy.NameAsc,
      AssetOrderBy.NameDesc,
      AssetOrderBy.PercentsFundedAsc,
      AssetOrderBy.PercentsFundedDesc,
    ];
  }


  export function optionsForUnderManagementAssets() {
    return [
      AssetOrderBy.CreatedDateNewerFirst,
      AssetOrderBy.CreatedDateOlderFirst,
      AssetOrderBy.NameAsc,
      AssetOrderBy.NameDesc,
    ];
  }

  export function optionsForDraftAssets() {
    return [
      AssetOrderBy.CreatedDateNewerFirst,
      AssetOrderBy.CreatedDateOlderFirst,
      AssetOrderBy.NameAsc,
      AssetOrderBy.NameDesc,
    ];
  }

  export function optionsForRealizedAssets() {
    return [
      AssetOrderBy.CreatedDateNewerFirst,
      AssetOrderBy.CreatedDateOlderFirst,
      AssetOrderBy.NameAsc,
      AssetOrderBy.NameDesc,
    ];
  }

  export function parse(sortStr: string): AssetOrderBy {
    return AssetOrderBy[sortStr];
  }
}

export default AssetOrderBy;

